import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Typography} from '@mui/material';
import './NotFound.scss';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="not-found-container">
            <div className="penguin">
                <div className="penguin-bottom">
                    <div className="right-hand"></div>
                    <div className="left-hand"></div>
                    <div className="right-feet"></div>
                    <div className="left-feet"></div>
                </div>
                <div className="penguin-top">
                    <div className="right-cheek"></div>
                    <div className="left-cheek"></div>
                    <div className="belly"></div>
                    <div className="right-eye">
                        <div className="sparkle"></div>
                    </div>
                    <div className="left-eye">
                        <div className="sparkle"></div>
                    </div>
                    <div className="tear"></div>
                    {/* Ajout de la larme */}
                    <div className="blush-right"></div>
                    <div className="blush-left"></div>
                    <div className="beak-top"></div>
                    <div className="beak-bottom"></div>
                </div>
            </div>
            <div className="message-box">
                <Typography variant="h1">Erreur 404</Typography>
                <Typography variant="body">Oups ! Il semblerait que cette page soit en construction... ou n'existe
                    pas.</Typography>
            </div>
            <Button variant="contained" color="primary" sx={{mt: 2}} onClick={() => navigate('/')}>Retourner à l'accueil</Button>
        </div>
    );
};

export default NotFound;
